import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import config from 'react-global-configuration'
import App from './App';
import Parse from 'parse';
import registerServiceWorker from './registerServiceWorker';
import { CookiesProvider } from 'react-cookie';
import { configureAnchors } from 'react-scrollable-anchor'
import ScrollToTop from './ScrollToTop'
import configuration from './GlobalConfig';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import './css/main.css';


config.set(configuration);

//configure ScrollableAnchors
// configureAnchors({ offset: 0, scrollDuration: 500 })

// Init Parse
Parse.initialize(
  config.get('PARSE_APPID'),
  config.get('PARSE_JSKEY')
);

Parse.serverURL = process.env.REACT_APP_PARSE_BACKEND // || process.env.NODE_ENV === "production" ? config.get('PARSE_URL') : process.env.NODE_ENV === "staging" ? config.get('STAGING_PARSE_URL') : config.get('DEV_PARSE_URL')
// Parse.serverURL = config.get('STAGING_PARSE_URL')


ReactDOM.render(
  <CookiesProvider>
    <BrowserRouter>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </BrowserRouter>
  </CookiesProvider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// /src/index.js